// import type {SwiperOptions} from '../../../../build/node_modules/swiper/types/swiper-options';

export class cRelatedProductsCarousel  {


  constructor() {

    const count     = document.querySelectorAll('.c-related-products-carousel .swiper-slide').length;
    const container = document.querySelector   ('.c-related-products-carousel'         ) as HTMLElement;
    const left      = document.querySelector   ('.c-related-products-carousel .c-left' ) as HTMLElement;
    const right     = document.querySelector   ('.c-related-products-carousel .c-right') as HTMLElement;


    if (container === null) return;

    let breakpoints: any = {};
    if (count === 2) {
      breakpoints = {
        768: {
          slidesPerView : 3,
          spaceBetween  : 16,
        },
      };
    }
    if (count >= 3) {
      breakpoints = {
        768: {
          slidesPerView : 3,
          spaceBetween  : 16,
        },
        1024: {
          slidesPerView : 4,
          spaceBetween  : 16,
        },
      };
    }


    // let options : SwiperOptions = {
    let options = {
      slidesPerView : 1,
      spaceBetween  : 16,
      speed         : 400,
      loop          : true,
      freeMode      : true,
      grabCursor    : true,
      mousewhele: true,
      keyboard  : true,
      // autoplay: {
      //   delay: 2000,
      //   disableOnInteraction: true,
      // },
      breakpoints: breakpoints,
      pagination: {
        el: '.c-related-products-carousel .swiper-pagination',
        clickable: true,
      },
      navigation: {
        'nextEl'   : '.c-related-products-carousel .swiper-button-next',
        'prevEl'   : '.c-related-products-carousel .swiper-button-prev',
        'addIcons' : false, // eigene Pfeile per :after in main.css
      },

    };

    const slider = new Swiper('.c-related-products-carousel .swiper', options);

    // container.style.opacity = "1";
    // right.addEventListener('click', () => slider.slideNext());
    // left.addEventListener('click', () => slider.slidePrev());


  }

}
